export default __webpack_public_path__ + "57a1848e29052255134ff1b67d1b6e78.png";